import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-425d1690")

_pushScopeId("data-v-425d1690")
const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = {
  key: 0,
  class: "absolute left-0 mt-1 w-[400px] bg-white border border-gray-lp-400 rounded-xl shadow-lg z-50 p-4"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-14px xxl:text-16px font-bold text-black-lp-100 mb-4" }, " Range saldo ", -1)
const _hoisted_4 = { class: "flex items-center gap-x-3 mb-6 relative" }
const _hoisted_5 = { class: "flex-1 flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "text-12px xxl:text-14px font-bold text-black-lp-100 mb-2" }, " Dari ", -1)
const _hoisted_7 = { class: "flex items-center border border-gray-lp-400 rounded-lg h-[45px]" }
const _hoisted_8 = { class: "text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3",
  alt: "chevron"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "absolute left-0 top-full mt-1 w-[80px] bg-white border border-gray-lp-400 rounded-lg shadow-lg z-[60]"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "mt-8 text-gray-lp-1000" }, "—", -1)
const _hoisted_12 = { class: "flex-1 flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "text-12px xxl:text-14px font-bold text-black-lp-100 mb-2" }, " Sampai ", -1)
const _hoisted_14 = { class: "flex items-center border border-gray-lp-400 rounded-lg h-[45px]" }
const _hoisted_15 = { class: "px-3 py-2 border-r border-gray-lp-1000 flex items-center gap-x-1 bg-gray-lp-1500" }
const _hoisted_16 = { class: "text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 opacity-30",
  alt: "chevron"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-1000 -mx-4 mb-4" }, null, -1)
const _hoisted_19 = { class: "flex items-center gap-x-4 bg-white pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_LpButton, {
      color: _ctx.isActive ? 'red-lp-100' : 'gray-lp-400',
      textColor: _ctx.isActive ? 'red-lp-100' : 'black-lp-100',
      iconColor: _ctx.isActive ? 'red-lp-100' : 'black-lp-100',
      outline: "",
      title: _ctx.selectedLabel,
      iconLeft: "ic-arrow-range",
      iconV2: true,
      isWidthFull: "",
      onClick: _ctx.toggleDropdown
    }, null, 8, ["color", "textColor", "iconColor", "title", "onClick"]),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _createVNode("div", {
                  class: "relative px-3 py-2 border-r border-gray-lp-1000 flex items-center gap-x-1 cursor-pointer hover:bg-gray-lp-1500 bg-white",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCurrencyDropdown && _ctx.toggleCurrencyDropdown(...args)))
                }, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.selectedCurrency), 1),
                  _hoisted_9,
                  (_ctx.isCurrencyDropdownOpen)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("div", {
                          class: "px-3 py-2 text-12px xxl:text-14px text-black-lp-300 hover:bg-gray-lp-1500",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectCurrency('IDR')), ["stop"]))
                        }, " IDR "),
                        _createVNode("div", {
                          class: "px-3 py-2 text-12px xxl:text-14px text-black-lp-300 hover:bg-gray-lp-1500",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectCurrency('MYR')), ["stop"]))
                        }, " MYR ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tempMin = $event)),
                  type: "text",
                  placeholder: "Masukkan jumlah",
                  class: "flex-1 px-3 py-2 outline-none text-12px xxl:text-14px text-black-lp-300 placeholder-gray-lp-500",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputNumber('tempMin')))
                }, null, 544), [
                  [_vModelText, _ctx.tempMin]
                ])
              ])
            ]),
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.selectedCurrency), 1),
                  _hoisted_17
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.tempMax = $event)),
                  type: "text",
                  placeholder: "Masukkan jumlah",
                  class: "flex-1 px-3 py-2 outline-none text-12px xxl:text-14px text-black-lp-300 placeholder-gray-lp-500",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInputNumber('tempMax')))
                }, null, 544), [
                  [_vModelText, _ctx.tempMax]
                ])
              ])
            ])
          ]),
          _hoisted_18,
          _createVNode("div", _hoisted_19, [
            _createVNode("button", {
              class: "flex-1 text-red-lp-2400 font-bold text-14px xxl:text-16px hover:text-red-lp-200",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, " Reset "),
            _createVNode("button", {
              class: "flex-1 bg-red-lp-2400 text-white py-2.5 rounded-lg font-bold text-14px xxl:text-16px hover:bg-red-lp-200 transition-colors",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
            }, " Terapkan ")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, () => (_ctx.isOpen = false)]
  ])
})